(function() {
	/**
	 * Render page
	 * @param {object} props - The Routing context
	 * @returns {object} Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderGenericPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/page.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				navRaw: null,	/* TODO: Probably obsolete. Fix or remove it later. Not relevant by now. */
				pageRaw: null,
				nav: null,
				pageContent: null,
				collections: null
			}
		};
		var queryString = WebBaseAprovLV.Utils.parseQuerystring(props.context.querystring);
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=3'),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		)
		.then(function(pageXhr, tmplPage, tmplBreadcrumb, tmplSidebar) {
			var pageRaw = Array.isArray(pageXhr) ? pageXhr[0] : (pageXhr || {});
			var limit = WebBaseAprovLV.pagingWindow || 10;
			var container;
			var codename;
			var filters = {
				articles: {
					data: null,
					query: null
				}
			};
			pageRaw.items = pageRaw.items || [];
			//if (pageRaw.items.length === 0) {
			//	return $.Deferred().reject(model);
			//}
			if (pageRaw.items.length !== 0
				&& pageRaw.items[0].elements
				&& pageRaw.items[0].elements.external_url
				&& pageRaw.items[0].elements.external_url.value !== '') {
				window.location.replace(pageRaw.items[0].elements.external_url.value);
			}
			model.data.pageRaw = pageRaw;
			model.data.pageContent = WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {};
			var now = new Date();
			// lookup of 'News Container' items wich has an empty news container and has selected categories in there.
			// Make additional requests afterwards only for those. If there are no selected categories,
			// there is no reason to make additional requests, cause there is an existing news page yet
			// with ALL news items there. So what?
			container = model.data.pageContent.container || [];
			var newsContainers = container.filter(function(component) {
				return component.system_type === 'news_container' && (component.container || []).length === 0 && ((component.news_categories || []).length > 0 || (component.news_tag || []).length > 0 || (component.quelix_searchstring));
			});
			// lookup of 'Publication Container' items
			var publicationContainers = container.filter(function(component) {
				return component.system_type === 'publication_container' && (component.container || []).length === 0 && (component.publication_categories || []).length > 0;
			});
			// lookup of 'Project Container' items
			var projectContainers = container.filter(function(component) {
				return component.system_type === 'project_container' && (component.container || []).length === 0 && (component.project_categories || []).length > 0;
			});
			// lookup of 'Appointment Container' items
			var appointmentContainers = container.filter(function(component) {
				return component.system_type === 'appointment_container' && (component.container || []).length === 0 && (component.appointment_categories || []).length > 0;
			});
			// lookup of 'FAQ Container' items
			var faqContainers = container.filter(function(component) {
				return component.system_type === 'faq_container' && (component.container || []).length === 0 && ((component.faq_categories || []).length > 0 || (component.faq_tag || []).length > 0);
			});
			// lookup of 'ServiceEditor Section'
			var serviceEditorSection = container.filter(function(component) {
				return component.system_type === 'serviceeditor_section' && (component.container || []).length === 0 && (component.service_ids || '').replace(/[^0-9,]/g, '').length > 0;
			});
			// lookup of 'Foreign Project ID'
			var newsForeignProjectID = newsContainers.map(function(component) {
				var customNewsProjectID = (component.foreign_project_id || '');
				if (customNewsProjectID.length) {
					return customNewsProjectID;
				}
			});
			// lookup of 'Foreign Project ID' Projects
			var projectForeignProjectID = projectContainers.map(function(component) {
				var customProjectProjectID = (component.foreign_project_id || '');
				if (customProjectProjectID.length) {
					return customProjectProjectID;
				}
			});
			// lookup of 'Quelix Searchstring'
			var newsQuelixSearchstring = newsContainers.map(function(component) {
				var customNewsQuelixSearchstring = (component.quelix_searchstring || '');
				if (customNewsQuelixSearchstring.length) {
					return customNewsQuelixSearchstring;
				}
			});
			// News KK request urls
			var newsRequests = newsContainers.map(function(component) {
				var query = ['?system.type=news&includeTotalCount=true'];
				var skip = parseInt(queryString[component.system_codename + '_skip'] || 0, 10);
				var categories = component.news_categories.map(function(category) {
					return category.codename;
				});
				var tags = (component.news_tag || []).map(function(tag) {
					return tag.codename;
				});
				// categories
				if (categories.length) {
					query.push('elements.news_categories' + ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				// tags
				if (tags.length) {
					query.push('elements.news_tag' + ((tags.length > 1) ? ('[any]=' + encodeURIComponent(tags.join(','))) : ('[contains]=' + encodeURIComponent(tags[0]))));
				}
				// sort order
				query.push('order=elements.date[desc]');
				// paging
				if (!isNaN(skip) && skip > 0) {
					query.push('skip=' + skip);
				}
				query.push('limit=' + limit);
				return query.join('&');
			});
			// Publications KK request urls
			var publicationsRequests = publicationContainers.map(function(component) {
				var query = ['?system.type=publication_item&includeTotalCount=true'];
				var skip = parseInt(queryString[component.system_codename + '_skip'] || 0, 10);
				var categoryQuery = queryString[component.system_codename + '_category'] || '';
				var categories = component.publication_categories.map(function(category) {
					return category.codename;
				}).filter(function(category) {
					if (categoryQuery.length > 0) {
						return category === categoryQuery;
					}
					return true;
				});
				var order = component.order__order.map(function(orderfield) {
					return orderfield.codename;
				});
				var tags = (component.news_tag || []).map(function(tag) {
					return tag.codename;
				});
				// categories
				if (categories.length) {
					query.push('elements.publication_categories' + ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				// tags
				if (tags.length) {
					query.push('elements.news_tag' + ((tags.length > 1) ? ('[any]=' + encodeURIComponent(tags.join(','))) : ('[contains]=' + encodeURIComponent(tags[0]))));
				}
				// sort order
				if (order.length) {
					if (/date_time_desc/i.test(order)) {
						query.push('order=elements.date_time[desc]');
					} else if (/date_time_asc/i.test(order)) {
						query.push('order=elements.date_time[asc]');
					} else if (/title_desc/i.test(order)) {
						query.push('order=elements.title[desc]');
					} else {
						query.push('order=elements.title[asc]');
					}
				} else {
					query.push('order=elements.title[asc]');
				}
				// paging
				if (!isNaN(skip) && skip > 0) {
					query.push('skip=' + skip);
				}
				query.push('limit=' + limit);
				return query.join('&');
			});
			// Projects KK request urls
			var projectRequests = projectContainers.map(function(component) {
				var query = ['?system.type=project_item'];
				var categories = component.project_categories.map(function(category) {
					return category.codename;
				});
				// categories
				if (categories.length) {
					query.push('elements.project_categories' + ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				// sort order
				query.push('order=elements.date_from[desc]');
				query.push('limit=3');
				return query.join('&');
			});
			// Appointments KK request urls
			var appointmentRequests = appointmentContainers.map(function(component) {
				var query = ['?system.type=appointment_item&includeTotalCount=true'];
				var skip = parseInt(queryString[component.system_codename + '_skip'] || 0, 10);
				var categories = component.appointment_categories.map(function(category) {
					return category.codename;
				});
				var tags = (component.appointment_tag || []).map(function(tag) {
					return tag.codename;
				});
				// categories
				if (categories.length) {
					query.push('elements.appointment_categories' + ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				// tags
				if (tags.length) {
					query.push('elements.appointment_tag' + ((tags.length > 1) ? ('[any]=' + encodeURIComponent(tags.join(','))) : ('[contains]=' + encodeURIComponent(tags[0]))));
				}
				query.push(['elements.date_from[gte]=', now.getFullYear(), '-', String('0' + (now.getMonth() + 1)).slice(-2), '-', String('0' + now.getDate()).slice(-2)].join(''));
				// sort order
				query.push('order=elements.date_from[asc]');
				// paging
				if (!isNaN(skip) && skip > 0) {
					query.push('skip=' + skip);
				}
				query.push('limit=' + limit);
				return query.join('&');
			});
			// FAQ KK request urls
			var faqRequests = faqContainers.map(function(component) {
				var query = ['?system.type=faq_item&includeTotalCount=true'];
				var categories = (component.faq_categories || []).map(function(category) {
					return category.codename;
				});
				var tags = (component.faq_tag || []).map(function(tag) {
					return tag.codename;
				});
				// categories
				if (categories.length) {
					query.push('elements.faq_categories' + ((categories.length > 1) ? ('[any]=' + encodeURIComponent(categories.join(','))) : ('[contains]=' + encodeURIComponent(categories[0]))));
				}
				// categories
				if (tags.length) {
					query.push('elements.faq_tag' + ((tags.length > 1) ? ('[any]=' + encodeURIComponent(tags.join(','))) : ('[contains]=' + encodeURIComponent(tags[0]))));
				}
				// sort order
				query.push('order=elements.question[asc]');
				query.push('limit=200');
				return query.join('&');
			});
			// ServiceEditor request (NEW: Quelix)
			var serviceEditorRequests = serviceEditorSection.map(function(component) {
				var service_ids_raw = (component.service_ids || '').replace(/[^0-9,]/g, '');
				var isIt = (WebBaseAprovLV.lang || '').toLowerCase() === 'it';
				var defaultSite   = isIt ? 'coll_newcivis_services_it' : 'coll_newcivis_services_de';
				var defaultClient = isIt ? 'civis_bz_it'              : 'civis_bz_de';
				var ids = service_ids_raw
					? service_ids_raw.split(',').map(function(s) { return s.trim(); }).filter(Boolean)
					: [];
				return {
					__type: 'serviceEditorQuelix',
					ids: ids,
					site: (defaultSite),
					client: (defaultClient)
				};
			});
			/* Fetch other needed things here: News, Publications... Register it as collections */
			// mapping list is the list of codenames that corresponds to the list of the dynamic additional requests that will follow here
			var mapping = newsContainers.concat(publicationContainers, appointmentContainers, faqContainers, serviceEditorSection, projectContainers).map(function(component) {
				return (component.system_codename || '');
			});
			// insert foreign project Id if present in news container
			var req = newsRequests.concat(publicationsRequests, appointmentRequests, faqRequests, serviceEditorRequests, projectRequests).map(function(kkUrl, index) {
				if (/system.type=news/i.test(kkUrl)) {
					if (typeof newsQuelixSearchstring[index] != 'undefined') {
						return WebBaseAprovLV.Utils.getSearchData(newsQuelixSearchstring[index]);
					} else {
						return WebBaseAprovLV.Utils.getKKData(kkUrl, (newsForeignProjectID[index] || []));
					}
				} else if (kkUrl && kkUrl.__type === 'serviceEditorQuelix') {
					return WebBaseAprovLV.Utils.getServiceEditorDataQuelix({
						lang: WebBaseAprovLV.lang,
						site: kkUrl.site,
						client: kkUrl.client,
						ids: kkUrl.ids
					});
				} else if (/system.type=project_item/i.test(kkUrl)) {
					return WebBaseAprovLV.Utils.getKKData(kkUrl, (projectForeignProjectID[index] || []));
				} else {
					return WebBaseAprovLV.Utils.getKKData(kkUrl);
				}
			});
			req.push(mapping);
			return $.when.apply($, req);
		}).then(function() {
			var key;
			var params = [];
			var args = Array.prototype.slice.call(arguments);
			var mapping = args.pop();
			var collections = {};
			args.forEach(function(item, i) {
				var codename = mapping.length >= i ? mapping[i] : '';
				var key;
				var qs = [];
				if (codename.length && item.length) {
					for (key in queryString) {
						switch (true) {
							case (new RegExp('^' + codename + '_(skip|limit)$', 'i')).test(key):
								// skip
								break;
							default:
								qs.push([key.toLowerCase(), queryString[key]].join('='));
								break;
						}
					}
					collections[codename] = {
						queryString: qs.join('&'),
						raw: (item || []).length ? item[0] : [],
						viewmodel: (item || []).length > 0 && (item[0].items || []).length > 0 ? (WebBaseAprovLV.Utils.getKKViewModel(item[0]) || []) : []
					};
				}
			});
			model.data.navRaw = {}; /* TODO: Nav Mode changed with Spotlight. Needed for Breadcrumb later. Fix the important things first. */
			if (model.data.pageRaw) {
				if (!model.data.pageRaw.items || !model.data.pageRaw.items.length) {
					WebBaseAprovLV.render404();
				} else {
					model.element = $('#content');
					model.data = $.extend(model.data, {
						nav: WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {},
						collections: collections
					});

					// show calculated last update time based on type
					WebBaseAprovLV.Utils.LastUpdateDateTime.calcAndShow(
						model.data.pageContent,
						model.data.collections,
						'defaultAndSpecial'
					);
				}
				return WebBaseAprovLV.Utils.transitionTo(model);
			} else {
				return $.Deferred().reject(model);
			}
		}).promise();
	};
})();
